const urlBase = '#{AFFIXE2_API_BASE_URL}#/api/';
const urlDataplateforme = '#{AFFIXE2_DATAPLATFORME}#';

export default {
  URL_SERVEUR: urlBase,
  BASE_URL: urlBase + 'services/',
  BASE_URL_DATAPLATEFORME: urlDataplateforme,
};
